import {
    Box,
    Center,
    Text,
    Button,
    VStack,
    HStack,
} from '@chakra-ui/react';
import React, { useState, useEffect } from "react";
import { useParams, Link } from 'react-router-dom';
import { HorizontalBar, Pagination, PaginationButton } from "./style";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import APIConfig from "../../../api/APIConfig";
import ReactLoading from "react-loading";


function ListMentee() {
    const [lowongan, setLowongan] = useState([]);
    const [idLowonganPeserta, setIdLowonganPeserta] = useState()
    const [spinner, setSpinner] = useState(false);  
    const { id } = useParams();
    const { idMentor } = useParams();

    let data = lowongan;

    const getMentee = async(idMentor) => {  
        setSpinner(true);
        const response = await APIConfig.get(`/v1/mentor/list-mentee/${idMentor}`);
        const result = await response.data;
        setIdLowonganPeserta(result.idLowonganPeserta);
        setLowongan(result);
        setSpinner(false);
    };

    useEffect(() => {
        getMentee(idMentor);
    }, []);

    const [currentPage, setCurrentPage] = useState(1);
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(data.length / 3); i++) {
        pageNumbers.push(i);
    }

    const indexOfLastData = currentPage * 3;
    const indexOfFirstData = indexOfLastData - 3;
    data = data.slice(indexOfFirstData, indexOfLastData);

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
      }
    
    return(
        <div className="container">
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'} pb={20}>
            <Text
                pt={3}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}>
                Mentee Management
            </Text>
            <HStack color={'gray.500'} pb={10}>
                <Link to={`/mitra/profile/mentor/list-mentor/${id}`}> Manajemen Mentor</Link>
                <p> / </p>
                <Link to="">Lihat Kinerja</Link>
            </HStack>
            <Box
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                alignContent={'center'}
                rounded={'2xl'}
                p={2}
                overflow={'hidden'}>
                <VStack align='center'>
                    {lowongan.length > 0 ? 
                        <Table style={{width: '95%', margin: '20px 0'}}>
                            <Thead className="head">
                                <Tr>
                                <Th className='layout'><p className='layoutp'>Id</p></Th>
                                <Th className='layout'><p className='layoutp'>Nama</p></Th>
                                <Th className='layout'><p className='layoutp'>Email</p></Th>
                                <Th className='layout'><p className='layoutp'>Nama Kegiatan</p></Th>
                                <Th className='layout'><p className='layoutp'>Posisi</p></Th>
                                <Th className='layout'><p className='layoutp'>Laporan</p></Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {data.map((data)=>
                                    <Tr>
                                    <Td className='layout'><p className='layoutp'>{data.idPeserta}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.namaPeserta}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.emailPeserta}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.namaProposal}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.posisi}</p></Td>
                                    <Td>        
                                        <Link to={`/mitra/profile/mentor/listlaporanpeserta/${id}/${idMentor}/${data.idLowonganPeserta}`} style={{textDecoration: 'none'}}>
                                        <Button 
                                            size='xs' rounded={'xl'} background='#6554C0' color='#FFFFFF' variant='solid' fontSize={'xs'} margin={'0 10px'}>
                                            Lihat Laporan
                                        </Button>
                                        </Link>
                                    </Td>
                                </Tr>
                                )}
  
                            </Tbody>
                        </Table>
                    : 
                    <Text fontSize={"large"} fontWeight={'600'}>Belum ada Mentee</Text>
                    }
                    {data.length > 0 ? (<HorizontalBar last={true} />) : null}
                                {pageNumbers.length > 1 && (
                                    <Pagination
                                    style={{margin: 'auto'}}>
                                        <PaginationButton onClick={() => 
                                            setCurrentPage(1)}>
                                            &lt;&lt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => 
                                            currentPage === 1 ? setCurrentPage(1) : setCurrentPage(currentPage-1)}>
                                            &lt;
                                        </PaginationButton>
                                        {pageNumbers.map((page) => (
                                            <PaginationButton
                                                unshow={
                                                    currentPage > 2 && pageNumbers.length - currentPage > 1
                                                    ? Math.abs(currentPage - page) > 2
                                                    : pageNumbers.length - currentPage < 2
                                                    ? pageNumbers.length - page > 4
                                                    : page > 5
                                                }
                                                active={currentPage === page}
                                                onClick={() => setCurrentPage(page)}
                                                >
                                                    {page}
                                            </PaginationButton>
                                        ))}
                                        <PaginationButton
                                            onClick={() =>
                                            currentPage === pageNumbers.length
                                                ? setCurrentPage(pageNumbers.length)
                                                : setCurrentPage(currentPage + 1)
                                            }
                                        >
                                            &gt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => setCurrentPage(pageNumbers.length)}>
                                            &gt;&gt;
                                        </PaginationButton>
                                    </Pagination>
                                )}
                        </VStack>
                    </Box>
                </VStack>
            </Center>
        </div>   
    );
}

export default ListMentee;